import BaseExecutor from 'services/sports/default/base-executor';
import Action from 'actions';
import BaseValidator from 'services/validations/base-validator';
import ProjectedOwnershipForceValidator from 'components/organisms/projected-ownership-force/validators/validator';
import {ForcedStackingValidatorBuilder} from 'services/sports/singlegame/validator/forced-stacking-validator-builder';
import {SingleGameValidatorBuilder} from 'services/validations/builders/single-game-validator-builder';

export default class UserAdjustmentsValidatorSinglegameBuilder extends BaseExecutor {
    getInterface() {
        const {
            sportConfig,
            projectedOwnershipForce,
            playersData: {preparedPlayers},
            singlegameForcedStacking: {settings: stacking},
        } = Action.getState();

        const validator = new BaseValidator();

        return validator;
    }
}
